import { type ComponentProps, forwardRef } from 'react';

import { cn } from '@air/utils-tailwind';

export type TableCellProps = {
  width?: number;
  minWidth?: number;
} & ComponentProps<'div'>;

export const TableCell = forwardRef<HTMLDivElement, TableCellProps>(
  ({ className, style, width, minWidth, ...restProps }: TableCellProps, forwardedRef) => (
    <div
      ref={forwardedRef}
      className={cn('table-cell w-full select-none items-center truncate p-4', className)}
      style={{
        flex: width ? `1 0 ${width}px` : `1 1 100%`,
        minWidth: minWidth || width ? `${minWidth}px` : 'unset',
        ...style,
      }}
      {...restProps}
    />
  ),
);

TableCell.displayName = 'TableCell';
